export const version = "transactions/5.7.0";
//# sourceMappingURL=_version.js.map